import React from 'react';
import { PencilIcon, TrashIcon } from 'lucide-react';
interface Vehicle {
  id: number;
  name: string;
  model: string;
  price: string;
  image: string;
  year: string;
  mileage: string;
  condition: 'New' | 'Used';
  transmission: string;
  fuelType: string;
}
interface VehicleTableProps {
  vehicles: Vehicle[];
  onEdit: (vehicle: Vehicle) => void;
  onDelete: (id: number) => void;
}
export function VehicleTable({
  vehicles,
  onEdit,
  onDelete
}: VehicleTableProps) {
  return <div className="overflow-x-auto" data-id="element-76">
      <table className="w-full" data-id="element-77">
        <thead data-id="element-78">
          <tr className="border-b border-gray-800" data-id="element-79">
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-80">
              Image
            </th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-81">
              Vehicle
            </th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-82">
              Year
            </th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-83">
              Condition
            </th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-84">
              Mileage
            </th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-85">
              Price
            </th>
            <th className="text-right py-4 px-4 text-sm font-semibold text-gray-300" data-id="element-86">
              Actions
            </th>
          </tr>
        </thead>
        <tbody data-id="element-87">
          {vehicles.map(vehicle => <tr key={vehicle.id} className="border-b border-gray-800 hover:bg-[var(--color-black-soft)] transition-colors" data-id="element-88">
              <td className="py-4 px-4" data-id="element-89">
                <img src={vehicle.image} alt={`${vehicle.name} ${vehicle.model}`} className="w-16 h-16 object-cover rounded" data-id="element-90" />
              </td>
              <td className="py-4 px-4" data-id="element-91">
                <div data-id="element-92">
                  <p className="text-white font-semibold" data-id="element-93">{vehicle.name}</p>
                  <p className="text-gray-400 text-sm" data-id="element-94">{vehicle.model}</p>
                </div>
              </td>
              <td className="py-4 px-4 text-white" data-id="element-95">{vehicle.year}</td>
              <td className="py-4 px-4" data-id="element-96">
                <span className={`inline-block px-2 py-1 text-xs font-medium rounded ${vehicle.condition === 'New' ? 'bg-emerald-500/10 text-emerald-400' : 'bg-blue-500/10 text-blue-400'}`} data-id="element-97">
                  {vehicle.condition}
                </span>
              </td>
              <td className="py-4 px-4 text-white" data-id="element-98">{vehicle.mileage}</td>
              <td className="py-4 px-4 text-white font-semibold" data-id="element-99">
                {vehicle.price}
              </td>
              <td className="py-4 px-4" data-id="element-100">
                <div className="flex items-center justify-end gap-2" data-id="element-101">
                  <button onClick={() => onEdit(vehicle)} className="p-2 text-[var(--color-gold)] hover:bg-[var(--color-gold)]/10 rounded transition-colors" aria-label={`Edit ${vehicle.name} ${vehicle.model}`} data-id="element-102">
                    <PencilIcon className="w-4 h-4" aria-hidden="true" data-id="element-103" />
                  </button>
                  <button onClick={() => {
                if (window.confirm(`Are you sure you want to delete ${vehicle.name} ${vehicle.model}?`)) {
                  onDelete(vehicle.id);
                }
              }} className="p-2 text-red-400 hover:bg-red-400/10 rounded transition-colors" aria-label={`Delete ${vehicle.name} ${vehicle.model}`} data-id="element-104">
                    <TrashIcon className="w-4 h-4" aria-hidden="true" data-id="element-105" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>

      {vehicles.length === 0 && <div className="text-center py-12" data-id="element-106">
          <p className="text-gray-400" data-id="element-107">
            No vehicles found. Add your first vehicle to get started.
          </p>
        </div>}
    </div>;
}